import * as common from './common.json';

export const sv = {
  common,
};
